// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"h3-z"};